goog.provide('el8.appshared.docTags.tooltips');

goog.require('el8.service.tooltip');


el8.appshared.docTags.tooltips.create = function(elt, item) {
    if (!item.getDocTagMaps) { return; }
    var $elt = $(elt);

    // The new chart feed has a single tag icon for all doctags
    el8.service.tooltip.create({
        anchor: $elt.find("img").first(),
        text: el8.template.appshared.docTags.tooltipCombined({
            docTagMaps: item.getDocTagMaps(),
            feedItemId: item.getFeedItemId()
        }),
        placement: 'top',
        theme: 'gray',
        showDelay: 750,
        interactive: true
    });

    $(document).on('click', '.add-edit-tags-trigger',  function(event) {
        var anchor = $(event.target).closest('a');
        var fid = $(anchor).attr('_fid');
        var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
        el8.appchart.dialog.docTags.show({doc: item});
        return false;
    });
};

el8.appshared.docTags.tooltips.destroy = function(span) {
     el8.service.tooltip.destroy($(span));
};
